import React from "react";
import { Slider, TextField, Typography, Box } from "@mui/material";
import { StyledQuestionTypography } from "../../style/styleComponents/StyledFinancialDetails";
import { getColor } from "../../style/color/color";
import { numberToWords } from "../../logic/NumberToWord";
import { fonts } from "../../style/fonts/fonts";

const IncomeSlider = ({ income, setIncome, question, placeholder }) => {
  const handleSliderChange = (event, newValue) => {
    setIncome(newValue);
  };

  const handleTextFieldChange = (event) => {
    const rawValue = event.target.value.replace(/[^0-9]/g, "");
    const value = parseInt(rawValue) || 0;
    if (!isNaN(value)) {
      setIncome(value.toFixed(0));
    } else {
      setIncome(0);
    }
  };
  const formatToIndianCurrency = (value) => {
    const numericValue = parseInt(value) || 0;
    return numericValue
      .toLocaleString("en-IN", {
        maximumFractionDigits: 0,
        style: "currency",
        currency: "INR",
      })
      .replace("₹", "₹ ");
  };

  return (
    <Box>
      <StyledQuestionTypography
        sx={{
          color: getColor.NeutralDark700,
          fontSize: 16,
          fontFamily: fonts.manrope,
          fontWeight: "700",
          mt: "30px",
        }}
      >
        {question}
      </StyledQuestionTypography>
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
          textAlign: "center",
          mt: 2,
        }}
      >
        <TextField
          value={formatToIndianCurrency(income)}
          type="tel"
          placeholder={placeholder}
          onChange={handleTextFieldChange}
          slotProps={{
            input: {
              sx: {
                textAlign: "center",
                fontWeight: "600",
                "& input": {
                  textAlign: "center",
                  fontWeight: "600",
                },
              },
              disableUnderline: true,
            },
          }}
          inputLabelProps={{
            sx: {
              ml: 10,
              mr: 10,
              textAlign: "center",
              justifyContent: "center",
            },
          }}
          variant="standard"
          sx={{
            width: "100%",
            maxWidth: "300px",
            borderRadius: 3,
            border: "0.50px #505662 solid",
            textAlign: "center",
            justifyContent: "center",
            p: "10px",
            mt: "20px",
          }}
        />
        <Typography
          variant="subtitle1"
          sx={{
            fontSize: { xs: "0.8rem", sm: "0.9rem" },
            textTransform: "initial",
            mt: "10px",
            color: getColor.NeutralDark700,
          }}
        >
          {`Rupees ${numberToWords(income)}`}
        </Typography>
      </Box>
      <Box
        sx={{
          width: "100%",
          height: 10,
          borderRadius: 10,
        }}
      >
        <Slider
          value={Number(income)}
          onChange={handleSliderChange}
          valueLabelDisplay="auto"
          min={20000}
          max={540000}
          step={1000}
          sx={{
            width: "90%",
            p: 1,
            mt: "10px",
            mr: "10px",
            ml: "10px",
            color: getColor.ExtendedpalettesSummerSkySS800,
            "& .MuiSlider-thumb": {
              height: 24,
              width: 24,
              backgroundColor: "white",
              border: "2px solid currentColor",
              "&:hover": {
                boxShadow: "inherit",
              },
            },
            "& .MuiSlider-track": {
              height: 8,
              borderRadius: 4,
            },
            "& .MuiSlider-rail": {
              height: 8,
              borderRadius: 4,
              backgroundColor: "rgba(0, 0, 0, 0.10)",
            },
          }}
        />
      </Box>
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          mt: "35px",
          ml: "12px",
          mr: "15px",
        }}
      >
        <Typography
          sx={{
            fontSize: 12,
            color: getColor.Grey,
          }}
        >
          ₹20,000
        </Typography>

        <Typography
          sx={{
            fontSize: 12,
            color: getColor.Grey,
          }}
        >
          ₹5,40,000+
        </Typography>
      </Box>
    </Box>
  );
};

export default IncomeSlider;
